import type { CourseModule } from "@/core/types";
import { lektionSchriftartWaehlen } from "./lektion-01-schriftart";
import { lektionSchriftgroesse } from "./lektion-02-schriftgroesse";
import { lektionAuszeichnungen } from "./lektion-03-auszeichnungen";
import { lektionFarbeUndHervorhebung } from "./lektion-04-farbe";
import { lektionAbschlussuebung } from "./lektion-05-abschluss";

export const modulSchriftarten: CourseModule = {
  id: "schriftarten",
  title: "Schriftarten und Zeichenformatierung",
  summary:
    "Schriftart, Größe, Auszeichnungen und Farbe gezielt einsetzen – die Grundlage " +
    "für jedes gut lesbare Word-Dokument.",
  level: "Grundlagen",
  lessons: [
    lektionSchriftartWaehlen,
    lektionSchriftgroesse,
    lektionAuszeichnungen,
    lektionFarbeUndHervorhebung,
    lektionAbschlussuebung,
  ],
};
